import { useState } from 'react'
import { useOutletContext, useParams } from 'react-router-dom'

import { Box, Button, Grid, Text } from '@factorialco/deprecated-design-system'
import { TrainingMembershipFragment } from 'generated/resources/graphql'

import DocumentType from 'modules/core/components/DocumentType'
import i18n from 'modules/core/lib/i18n'

import { useTrainingsMixedFiles } from 'modules/trainings/hooks/Files/useMixedFiles'
import { useSessionFilesContext } from 'modules/trainings/hooks/SessionFiles/useSessionFilesContext'
import { useTrainingFilesContext } from 'modules/trainings/hooks/TrainingFiles/useTrainingFilesContext'

interface Props {
  fileNavigation: (fileId: string) => string | undefined
  restrictedNavigation: boolean
  accessId: number
}
const MAX_FILES = 6
export const MyTrainingFiles = ({ fileNavigation, restrictedNavigation, accessId }: Props) => {
  const { trainingId } = useParams()
  const { trainingFiles } = useTrainingFilesContext()
  const { sessionFiles } = useSessionFilesContext()
  const { trainingMemberships } = useOutletContext<{
    trainingMemberships: TrainingMembershipFragment[]
  }>()
  const trainingMembership = trainingMemberships.find(
    (membership) => membership.trainingId === Number(trainingId) && membership.accessId === accessId
  )
  const [isExpanded, setIsExpanded] = useState(false)
  const { buildFilesList } = useTrainingsMixedFiles()

  const allFiles = buildFilesList({
    fileNavigation,
    trainingFiles,
    sessionFiles,
    membershipFiles: trainingMembership?.trainingMembershipFiles,
  })

  const expandable = allFiles.length > MAX_FILES
  const files = isExpanded ? allFiles : allFiles.slice(0, MAX_FILES)

  return (
    <Box gap="s16">
      <Grid>
        {files.map((file, index) => {
          return (
            <Box
              key={index}
              alignItems="center"
              justifyContent="spaceBetween"
              borderRadius={{ all: 'abs008' }}
              border={{
                all: {
                  width: 's1',
                  style: 'solid',
                  color: 'grey400',
                },
              }}
              flexDirection="row"
              paddingX="s24"
              paddingY="s16"
            >
              <Box flexDirection="row" gap="s12" alignItems="center">
                <DocumentType mimetype={file.contentType} />
                <Text.Normal size="300">{file.filename}</Text.Normal>
              </Box>
              {!restrictedNavigation && (
                <Box flexDirection="row" gap="s8">
                  <Button.Router type="secondary" to={file.url} iconName="download" />
                  {file.navigation && (
                    <Button.Router type="secondary" to={file.navigation} iconName="arrow-right" />
                  )}
                </Box>
              )}
            </Box>
          )
        })}
      </Grid>
      {expandable && (
        <Box alignSelf="flexStart" cursor="pointer" onClick={() => setIsExpanded(!isExpanded)}>
          <Text.Normal underlined>
            {isExpanded
              ? i18n.t('trainings.my_training.show_less')
              : i18n.t('trainings.my_training.show_more')}
          </Text.Normal>
        </Box>
      )}
    </Box>
  )
}
